import api from './api';
import { ServiceDetailResponse, ServiceFormData, ServiceListResponse } from '../types/service';

export const serviceService = {
    // GET /api/site/services?page=1&limit=10&search=...
    list: async (params?: {
        page?: number;
        limit?: number;
        search?: string;
    }): Promise<ServiceListResponse> => {
        const response = await api.get('services', { params });
        return response.data;
    },

    // GET /api/site/services/:id
    getById: async (id: string): Promise<ServiceDetailResponse> => {
        const response = await api.get(`services/${id}`);
        return response.data;
    },

    // POST /api/site/services
    create: async (data: ServiceFormData): Promise<ServiceDetailResponse> => {
        const response = await api.post('services', data);
        return response.data;
    },

    // PUT /api/site/services/:id
    update: async (id: string, data: Partial<ServiceFormData>): Promise<ServiceDetailResponse> => {
        const response = await api.put(`services/${id}`, data);
        return response.data;
    },

    // DELETE /api/site/services/:id
    delete: async (id: string): Promise<{ success: boolean; message?: string }> => {
        const response = await api.delete(`services/${id}`);
        return response.data;
    },
};
